import { FolderItem } from 'types/song';

export const getNextFolderTitle = (songsFolders: FolderItem[]) => {
  const prefix = 'Song folder';
  const number = songsFolders.reduce((res, { title }: any) => {
    const matchResults = title.match(new RegExp(`^(${prefix} ?)([0-9]*)$`));

    if (!matchResults) {
      return res;
    }

    if (!matchResults[2]) {
      return Math.max(res || 0, 0);
    }

    return Math.max(Number(matchResults[2]), res || 0);
  }, NaN);
  return Number.isNaN(number) ? prefix : `${prefix} ${number + 1}`;
};
